<hr />
<footer>
  <p class="text-center">
    &copy; {new Date().getFullYear()} -
    <b>Gast Inv.</b>
  </p>
</footer>
